function stepperInput() {
  const stepperInput = $('.stepper-input');
  stepperInput.each(function () {
    let input = $(this).find('.stepper-input__input');
    let count = $(this).find('.stepper-input__container').find('input');
    console.log(count.attr('value'));
    let btnLeft = $(this).find('.stepper-input__button--left');
    let btnRight = $(this).find('.stepper-input__button--right');

    btnLeft.click(function () {
      let value = parseInt(input.text());
      input.text(value + 1);
      count.attr('value', value + 1);
    });
    btnRight.click(function () {
      let value = parseInt(input.text());
      if (value > 1) {
        input.text(value - 1);
        count.attr('value', value - 1); 
      }
    });
  });
}
$(document).ready(function () {
  stepperInput();
});